import { AuthService } from 'src/app/shared/service/auth.service';
import { AuthGuard } from '../../shared/guard/auth.guard';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import * as firebase from 'firebase';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { BusinessNew } from 'src/app/models/business-new';

@Injectable({
  providedIn: 'root'
})
export class FireBusinessAssessmentService {
  businessAssessmentsRef: AngularFireList<any>; // Reference to Assessment data list, its an Observable
  businessAssessmentRef: AngularFireObject<any>; // Reference to assessment object
  public database = firebase.database();
  public ref;
  public actRoute: ActivatedRoute;
  public router: Router;
  public auth: AuthGuard;
  public dbStore = firebase.firestore();
  private dbPath = 'users';
  private assessmentsTable = "business-assessment-inputs";

  sustainibleBusinessAssessmentRef: AngularFirestoreCollection<BusinessNew> = null;

  constructor(
    private db: AngularFireDatabase, 
    private authService: AuthService, 
    private guard: AuthGuard, 
    private dbstore: AngularFirestore
    ) {
    this.sustainibleBusinessAssessmentRef = dbstore.collection(this.assessmentsTable);
  }


  // Firestore Assessment Create the Assessment in FireStore
  createSustainibleeAssessment(sustainible: BusinessNew): void {
    this.sustainibleBusinessAssessmentRef.add({ ...sustainible });

  }

  updateSustainibleeAssessment(id: string, value: any): Promise<void> {
    return this.sustainibleBusinessAssessmentRef.doc(id).update(value);

  }

  deleteSustainibleeAssessment(id: string): Promise<void> {
    return this.sustainibleBusinessAssessmentRef.doc(id).delete();

  }

  readSustainibleeAssessmentList(): AngularFirestoreCollection<BusinessNew> {
    return this.sustainibleBusinessAssessmentRef;

  }

  readAssessmentsListBusiness() {//function name changed
    
    this.globalAdminCode(this.guard.uid);
 
   const list = this.dbstore.collection<any>(this.assessmentsTable, ref => ref.where('userID', '==', this.guard.uid));
    return list;
  }


  readSustainibleAssessment(id: string) {
    return this.sustainibleBusinessAssessmentRef.doc(id);
  }

  deleteAllSustainibleeAssessment() {
    this.sustainibleBusinessAssessmentRef.get().subscribe(
      (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          doc.ref.delete();
        });
      },
      error => {
        console.error('Error deleting all documents: ', error);
      });
  }

  /**
   * Create assessment in firestore
   * @param business - data about business assessment
   * @returns 
   */

  async createAssessment(business: BusinessNew): Promise<string> {
    const adminCodePayload: any = (
      await this.dbStore
        .collection(this.dbPath)
        .doc(this.authService.userData?.uid || this.guard.uid)
        .get()
    )?.data()?.adminCode;
   // const adminCode = (await this.dbStore.collection(this.dbPath).doc(this.guard.uid).get())?.data()?.adminCode;
    const data = {
      userID: this.authService.userData?.uid || this.guard.uid,
      adminCode: !adminCodePayload?.disabled ? adminCodePayload: null,
      ...business
    };

    const res = await this.sustainibleBusinessAssessmentRef.add(data);
    return res.id;

  }

 public adminCode2: any;
  businessAssessmentInput: any;

 globalAdminCode(uid: string) {
    
     this.dbStore
     .collection(this.dbPath)
     .doc(uid)
     .get()
     .then((snapshot) => {
      this.businessAssessmentInput = snapshot.data();
      this.adminCode2 = this.businessAssessmentInput.adminCode;
    
  });
}


  ReadAssessment(id: string) {
    this.businessAssessmentRef = this.db.object(`users/${this.guard.uid}/` + id);
    return this.businessAssessmentRef;
  }

  readAssessmentsList() {
    this.globalAdminCode(this.guard.uid);
   const list = this.dbstore.collection<any>(this.assessmentsTable, ref => ref.where('userID', '==', this.guard.uid) || ref.where('adminCode', '==', this.adminCode2));
    return list
  }


  UpdateAssessments(business: BusinessNew) {
    this.businessAssessmentRef.update({
      busiName: business.busiName,
      busiFirstName: business.busiFirstName,
      busiLastName: business.busiLastName,
      busiTelephone: business.busiTelephone,
      busiEmail: business.busiEmail,
      offerType: business.offerType,
      offerIndustry: business.offerIndustry,
      offerIndustrySubcategory: business.offerIndustrySubcategory,
      operationsMethods: business.operationsMethods,   
      capitalSeeking: business.capitalSeeking,
      busiPlanArray: business.busiPlanArray,
      offerDifferentiation: business.offerDifferentiation,
      offerSupplierPower: business.offerSupplierPower,
      knownCompetition: business.knownCompetition,
      industryBarriers: business.industryBarriers,
      industryBarriersOvercome: business.industryBarriersOvercome,
      generalIndustryBarriers: business.generalIndustryBarriers,
      generalBarriersOvercome: business.generalBarriersOvercome,
      marketTargetB2BC: business.marketTargetB2BC,
      B2CTargetMarket: business.B2CTargetMarket,
      B2BTargetMarket: business.B2BTargetMarket, 
      pmfCompetitorDissatisfaction: business.pmfCompetitorDissatisfaction,
      //pmfB2BCompetitorDissatisfaction: business.pmfB2BCompetitorDissatisfaction,
      //pmfB2CCompetitorDissatisfaction: business.pmfB2CCompetitorDissatisfaction,
      marketingWebsite: business.marketingWebsite, 
      marketingBrand: business.marketingBrand,
      marketingEffectiveness: business.marketingEffectiveness,
      marketingNetworkMaterial: business.marketingNetworkMaterial,
      marketingEmailList: business.marketingEmailList,
      marketingSocialMedia: business.marketingSocialMedia,
      customerEngagement: business.customerEngagement,
      customerService: business.customerService,
      busiRegType: business.busiRegType,
      legalOpAgreement: business.legalOpAgreement,
      legalDisclaimers: business.legalDisclaimers,
      legalIP: business.legalIP,
      financePaymentSystem: business.financePaymentSystem,
      financeAccountingSystem: business.financeAccountingSystem,
      operatingSOP: business.operatingSOP,
      operatingProductionProcess: business.operatingProductionProcess,
      teamMembersQuan: business.teamMembersQuan,
      teamLeaderSerialEntrp: business.teamLeaderSerialEntrp,
      teamRole: business.teamRole,
      teamIndustryKnowledge: business.teamIndustryKnowledge,
      teamTime: business.teamTime,
      teamNetwork: business.teamNetwork,
      teamTimeManage: business.teamTimeManage,
      teamUnproductivity: business.teamUnproductivity,
      teamPassion: business.teamPassion,
      teamWorkLife:business.teamWorkLife,
      teamHiring: business.teamHiring,
      hrEmployeeRetention: business.hrEmployeeRetention,
      hiringPractices: business.hiringPractices,
    });
  }

  DeleteAssessment() {
    this.businessAssessmentRef = this.db.object('users/');
    this.businessAssessmentRef.remove();
  }

}